import { useContext } from "react";
import { Alert, Col, Row } from "antd";
import { ICompany } from "../../interfaces/company";
import { FreireContext } from "../../utils/freireContext";
import * as texts from "./locales";
import { IconPack } from "../../components/WhitelabelThemesProvider";

type Props = {
  visible: boolean;
  parentCompany?: ICompany;
  parentCompanyIconPack?: IconPack;
  colSpan?: number;
};

const AlertParentCompanyIconPack = ({
  visible,
  parentCompany,
  parentCompanyIconPack,
  colSpan = 18,
}: Props) => {
  const { freire } = useContext(FreireContext);

  if (!visible || !parentCompanyIconPack || !parentCompany?.iconPack) {
    return null;
  }

  return (
    <Row gutter={[16, 0]}>
      <Col span={colSpan}>
        <Alert
          type="warning"
          style={{ marginTop: 10 }}
          message={
            <span>
              {freire(texts.THE_PARENT_COMPANY)}{" "}
              <b>{parentCompany?.companyName}</b>{" "}
              {freire(texts.PARENT_COMPANY_HAS_CUSTOM_PIN)}{" "}
              <b>{parentCompanyIconPack?.name}</b> <br />
              {freire(texts.PARENT_COMPANY_HAS_CUSTOM_PIN_2)}
            </span>
          }
        />
      </Col>
    </Row>
  );
};

export default AlertParentCompanyIconPack;
